import {
  Box,
  Flex,
  Text,
  Input,
  InputGroup,
  InputRightElement,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  Badge,
  Alert,
  AlertDescription,
  TableContainer,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Select,
  SimpleGrid,
  Image,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import React, { useState, useRef } from "react";
import { FiEdit, FiUploadCloud, FiSearch, FiPlus } from "react-icons/fi";
import Navbar from "../Components/Navbar/Navbar";
import Sidebar from "../Components/Sidebar";

const initialTeams = [
  {
    name: "Michal Michalski",
    shortName: "Michal Michalski",
    category: "Mixed Martial Arts",
    slug: "michal-michalski",
  },
  {
    name: "Marcelo Morrelli",
    shortName: "Marcelo Morrelli",
    category: "Mixed Martial Arts",
    slug: "marcelo-morrelli",
  },
  {
    name: "Patryk Surdyn",
    shortName: "Patryk Surdyn",
    category: "Mixed Martial Arts",
    slug: "patryk-surdyn",
  },
  {
    name: "Wiktor Zalewski",
    shortName: "Wiktor Zalewski",
    category: "Mixed Martial Arts",
    slug: "wiktor-zalewski",
  },
  {
    name: "Romain Debienne",
    shortName: "Romain Debienne",
    category: "Mixed Martial Arts",
    slug: "romain-debienne",
  },
  {
    name: "Marcin Wojcik",
    shortName: "Marcin Wojcik",
    category: "Mixed Martial Arts",
    slug: "marcin-wojcik",
  },
  {
    name: "Emmanuel Buttigieg",
    shortName: "Emmanuel Buttigieg",
    category: "Boxing",
    slug: "emmanuel-buttigieg",
  },
];

const categories = ["Mixed Martial Arts", "Boxing", "Handball", "Aussie Rules"];

const SIDEBAR_WIDTH = "240px";

export default function Teams() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [teams, setTeams] = useState(initialTeams);
  const [searchTerm, setSearchTerm] = useState("");
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    shortName: "",
    category: "",
    slug: "",
  });
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileUpload = () => {
    fileInputRef.current.click();
  };

  const handleEdit = (team) => {
    setEditData(team);
    setFormData({
      name: team.name,
      shortName: team.shortName,
      category: team.category,
      slug: team.slug,
    });
    setImagePreview(null);
    onOpen();
  };

  const handleAddNew = () => {
    setEditData(null);
    setFormData({
      name: "",
      shortName: "",
      category: "",
      slug: "",
    });
    setImagePreview(null);
    onOpen();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (editData) {
      setTeams((prev) =>
        prev.map((t) => (t.slug === editData.slug ? { ...t, ...formData } : t))
      );
    } else {
      setTeams((prev) => [...prev, formData]);
    }
    onClose();
  };

  const filteredTeams = teams.filter(
    (t) =>
      t.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.slug?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        p={{ base: 4, md: 8 }}
        bg="#f8f9fd"
        minH="100vh"
        mt="80px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
      >
        {/* HEADER */}
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          mb={8}
          align={{ base: "flex-start", md: "center" }}
          gap={4}
        >
          <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="700" color="#344767">
            Manage Teams
          </Text>

          <Flex gap={3} w={{ base: "100%", md: "auto" }} direction={{ base: "column", sm: "row" }}>
            <InputGroup maxW={{ base: "100%", sm: "300px" }} size="md">
              <Input
                placeholder="Search team, category..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                bg="white"
                borderRadius="8px"
                border="1px solid #e2e8f0"
                fontSize="sm"
                _focus={{
                  borderColor: "#5e72e4",
                  boxShadow: "0 0 0 1px #5e72e4",
                }}
              />
              <InputRightElement color="gray.400">
                <FiSearch />
              </InputRightElement>
            </InputGroup>

            <Button
              leftIcon={<FiPlus />}
              bg="#5e72e4"
              color="white"
              fontSize="sm"
              borderRadius="8px"
              h="40px"
              px={6}
              _hover={{ bg: "#4e62d4" }}
              onClick={handleAddNew}
            >
              Add New
            </Button>
          </Flex>
        </Flex>

        {/* INFO ALERT */}
        <Alert
          bg="blue.50"
          borderLeft="4px solid"
          borderColor="blue.400"
          borderRadius="8px"
          mb={8}
          p={4}
        >
          <AlertDescription fontSize="sm" color="blue.800" fontWeight="500">
            Teams will be automatically added when the Fetch Games or Fetch Odds
            cron job runs on the server. You can also add teams manually.
          </AlertDescription>
        </Alert>

        {/* DESKTOP TABLE */}
        <Box
          bg="white"
          borderRadius="12px"
          boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          overflow="hidden"
          border="1px solid #f0f2f5"
          display={{ base: "none", md: "block" }}
        >
          <TableContainer overflowX="auto">
            <Table variant="simple" size={{ base: "sm", md: "md" }}>
              <Thead bg="#1f15da">
                <Tr>
                  <Th color="white" fontSize="xs" py={4} border="none">TEAM</Th>
                  <Th color="white" fontSize="xs" py={4} border="none">SHORT NAME</Th>
                  <Th color="white" fontSize="xs" py={4} border="none">CATEGORY</Th>
                  <Th color="white" fontSize="xs" py={4} border="none" textAlign="right">ACTION</Th>
                </Tr>
              </Thead>

              <Tbody>
                {filteredTeams.map((team, index) => (
                  <Tr key={index} _hover={{ bg: "#f8f9fa" }}>
                    <Td py={4}>
                      <Flex align="center" gap={3}>
                        <Avatar
                          name={team.name}
                          bg="#5e72e4"
                          color="white"
                          size="sm"
                        />
                        <Text fontWeight="700" color="#344767" fontSize="sm">{team.name}</Text>
                      </Flex>
                    </Td>

                    <Td py={4} color="#67748e" fontSize="xs">{team.shortName}</Td>
                    <Td py={4}>
                      <Badge
                        bg="rgba(94, 114, 228, 0.1)"
                        color="#5e72e4"
                        px={3}
                        py={1}
                        borderRadius="full"
                        fontSize="10px"
                        fontWeight="700"
                      >
                        {team.category}
                      </Badge>
                    </Td>

                    <Td py={4} textAlign="right">
                      <Button
                        size="xs"
                        variant="outline"
                        onClick={() => handleEdit(team)}
                        borderColor="#e2e8f0"
                        borderRadius="6px"
                        fontSize="xs"
                        leftIcon={<FiEdit />}
                        _hover={{ bg: "gray.50" }}
                      >
                        Edit
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>

        {/* MOBILE CARD VIEW */}
        <VStack display={{ base: "flex", md: "none" }} spacing={4} align="stretch">
          {filteredTeams.map((team, index) => (
            <Box
              key={index}
              bg="white"
              p={4}
              borderRadius="12px"
              boxShadow="sm"
              border="1px solid"
              borderColor="gray.200"
            >
              {/* Name Row */}
              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Name
                </Text>
                <Flex align="center" gap={2}>
                  <Avatar
                    name={team.name}
                    bg="#5e72e4"
                    color="white"
                    size="xs"
                  />
                  <Text fontSize="sm" color="#344767">
                    {team.name}
                  </Text>
                </Flex>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              {/* Short Name Row */}
              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Short Name
                </Text>
                <Text fontSize="sm" color="#67748e">
                  {team.shortName}
                </Text>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              {/* Category Row */}
              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Category
                </Text>
                <Text fontSize="sm" color="#344767">
                  {team.category}
                </Text>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              {/* Action Row */}
              <Flex justify="space-between" align="center">
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Action
                </Text>
                <Button
                  size="xs"
                  bg="#5e72e4"
                  color="white"
                  onClick={() => handleEdit(team)}
                  borderRadius="6px"
                  fontSize="xs"
                  leftIcon={<FiEdit />}
                  _hover={{ bg: "#4e62d4" }}
                >
                  Edit
                </Button>
              </Flex>
            </Box>
          ))}
        </VStack>

        {/* ADD/EDIT MODAL */}
        <Modal isOpen={isOpen} onClose={onClose} size={{ base: "sm", md: "4xl" }} isCentered>
          <ModalOverlay backdropFilter="blur(4px)" />
          <ModalContent borderRadius="16px" mx={4}>
            <ModalHeader borderBottom="1px solid #f0f2f5" py={4} color="#344767">
              <Text fontSize="lg" fontWeight="700">
                {editData ? "Edit Team" : "Add New Team"}
              </Text>
            </ModalHeader>
            <ModalCloseButton top={4} />
            <ModalBody p={{ base: 5, md: 8 }}>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
                {/* Left Side: Image Upload */}
                <Box>
                  <FormLabel fontSize="xs" fontWeight="700" color="#525f7f" mb={2}>TEAM LOGO</FormLabel>
                  <Box
                    border="2px dashed"
                    borderColor="#e2e8f0"
                    borderRadius="12px"
                    p={4}
                    position="relative"
                    bg="#f8f9fd"
                    textAlign="center"
                    transition="all 0.2s"
                    _hover={{ borderColor: "#5e72e4" }}
                  >
                    <Input
                      type="file"
                      ref={fileInputRef}
                      display="none"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                    <Image
                      src={
                        imagePreview ||
                        "https://via.placeholder.com/150x150?text=Upload+Logo"
                      }
                      alt="Team Preview"
                      w="100%"
                      h="250px"
                      objectFit="contain"
                      borderRadius="8px"
                      mb={4}
                    />
                    <Button
                      leftIcon={<FiUploadCloud />}
                      bg="white"
                      size="sm"
                      boxShadow="sm"
                      onClick={triggerFileUpload}
                      borderRadius="8px"
                      fontSize="xs"
                      _hover={{ bg: "gray.50" }}
                    >
                      Upload New Image
                    </Button>
                  </Box>
                  <Text fontSize="xs" color="#8898aa" mt={4} lineHeight="tall">
                    Supported Files:{" "}
                    <Text as="span" fontWeight="700">.png, .jpg, .jpeg.</Text>
                    {" "}Resized to <Text as="span" fontWeight="700">150x150px</Text>
                  </Text>
                </Box>

                {/* Right Side: Form Fields */}
                <VStack spacing={5} align="stretch">
                  <FormControl isRequired>
                    <FormLabel fontSize="xs" fontWeight="700" color="#525f7f">CATEGORY</FormLabel>
                    <Select
                      placeholder="Select Category"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      h="45px"
                      borderRadius="8px"
                      borderColor="#e2e8f0"
                      fontSize="sm"
                      _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                    >
                      {categories.map((cat) => (
                        <option key={cat} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel fontSize="xs" fontWeight="700" color="#525f7f">NAME</FormLabel>
                    <Input
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter team name"
                      h="45px"
                      borderRadius="8px"
                      borderColor="#e2e8f0"
                      fontSize="sm"
                      _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel fontSize="xs" fontWeight="700" color="#525f7f">SHORT NAME</FormLabel>
                    <Input
                      name="shortName"
                      value={formData.shortName}
                      onChange={handleChange}
                      placeholder="Enter short name"
                      h="45px"
                      borderRadius="8px"
                      borderColor="#e2e8f0"
                      fontSize="sm"
                      _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel fontSize="xs" fontWeight="700" color="#525f7f">SLUG</FormLabel>
                    <Input
                      name="slug"
                      value={formData.slug}
                      onChange={handleChange}
                      placeholder="Enter slug"
                      h="45px"
                      borderRadius="8px"
                      borderColor="#e2e8f0"
                      fontSize="sm"
                      _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                    />
                    <Text fontSize="10px" color="red.400" mt={1} fontWeight="600">
                      * Spaces are not allowed
                    </Text>
                  </FormControl>
                </VStack>
              </SimpleGrid>

              <Button
                bg="#5e72e4"
                color="white"
                w="100%"
                h="45px"
                fontSize="sm"
                fontWeight="700"
                borderRadius="8px"
                _hover={{ bg: "#4e62d4" }}
                onClick={handleSubmit}
                mt={8}
              >
                Save Team
              </Button>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
}
